import { createFileRoute } from "@tanstack/react-router";
import { useCallback } from "react";
import { JournalPage, type JournalSearch } from "@/features/journals/JournalPage";
import { journalListColumns } from "@patronix/domain/list";
import { viewSearch } from "@/lib/listView";

// Journal of posted shipments (features/journals).
export const Route = createFileRoute("/_app/sales/shipments")({
  validateSearch: (raw: Record<string, unknown>): JournalSearch => {
    const s: JournalSearch = { q: typeof raw.q === "string" ? raw.q.slice(0, 40) : "" };
    if (typeof raw.doc === "string" && raw.doc) s.doc = raw.doc;
    return { ...s, ...viewSearch(journalListColumns, raw) };
  },
  component: Page,
});

function Page() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const setSearch = useCallback(
    (patch: Partial<JournalSearch>) => void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true }),
    [navigate],
  );
  return <JournalPage kind="shipments" search={search} setSearch={setSearch} />;
}
